import { ACCESS_PERIPHERAL_TYPES } from 'helpers/globals'

export default function deleteDoor(state, action) {
  const { id } = action
  const { entities, entities: { doorControllers, doors, wires }, currentEntity, ui: { modal } } = state

  const door = doors.byId[id]

  if (!door) return state

  const byId = { ...doors.byId }
  delete byId[id]

  const doorController = doorControllers.byId[door.controllerId]

  const newPeripherals = {}
  ACCESS_PERIPHERAL_TYPES.forEach(peripheralType => {
    const newById = { ...entities[peripheralType].byId }
    door[peripheralType].forEach(peripheralId => delete newById[peripheralId])

    newPeripherals[peripheralType] = {
      allIds: entities[peripheralType].allIds.filter(peripheralId => !door[peripheralType].includes(peripheralId)),
      byId: newById
    }
  })

  const wiresById = { ...wires.byId }
  const wire = Object.values(wiresById).find(wire => wire.start.type === 'door' && wire.start.id === id)
  let newWireIds = [...wires.allIds]
  if (wire) {
    delete wiresById[wire.id]
    newWireIds = wires.allIds.filter(wireId => wireId !== wire.id)
  }

  return Object.assign({}, state, {
    entities: {
      ...entities,
      doorControllers: {
        allIds: doorControllers.allIds,
        byId: Object.assign({}, doorControllers.byId, doorController && {
          [door.controllerId]: {
            ...doorController,
            doorIds: doorController.doorIds.filter(doorId => doorId !== id)
          }
        })
      },
      doors: {
        byId,
        allIds: doors.allIds.filter(currentId => currentId !== id)
      },
      wires: {
        byId: wiresById,
        allIds: newWireIds
      },
      ...newPeripherals
    }
  },
  (modal !== 'DoorControllerDesigner' || (currentEntity.type === 'door' && currentEntity.id === id)) && {
    currentEntity: {
      type: 'doorController',
      id: door.controllerId
    }
  },
  !doorController && {
    currentEntity: {
      type: 'map'
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/deleteDoor.js